var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcRestaurantOn = function SvgIcRestaurantOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D85FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 4v17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    d: "M18 10c0-1.6-1.333-4.333-2-6v9c.667 0 2-1.4 2-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D85FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 21v-8m0 0V4c.667 1.667 2 4.4 2 6s-1.333 3-2 3M5.5 4c0 3-.5 7 2.5 7s2.5-4 2.5-7"
  })));
};
export default SvgIcRestaurantOn;